import { EnumCountry } from './Generated';

/**
 * Number of digits a complete postal code has, for the countries whose localities Stammdaten can
 * look up. Countries missing here get no lookup and keep a free-form postal code field —
 * alphanumeric codes (NL "1234 AB", GB "SW1A 1AA", PL "00-950") must never be blocked or truncated.
 *
 * The backend validates the postal code independently and stays the authority on what is a valid
 * lookup; this table only drives input affordances (field length, digits-only, when a code is
 * complete enough to ask). Keep it in step with `PostalCodeLookupService.IsValidZip`.
 */
// @ai-generated 2026-08-17T13:24:12+00:00 by matthias.gessinger@synqony.com using Claude Opus 5
const POSTAL_CODE_DIGITS: Partial<Record<EnumCountry, number>> = {
    [EnumCountry.Germany]: 5,
    [EnumCountry.Austria]: 4,
    [EnumCountry.Switzerland]: 4,
    [EnumCountry.Liechtenstein]: 4,
};

/** Length of a numeric postal code, or undefined where the field stays free-form. */
// @ai-generated 2026-08-17T13:24:12+00:00 by matthias.gessinger@synqony.com using Claude Opus 5
export function postalCodeDigits(country: EnumCountry): number | undefined {
    return POSTAL_CODE_DIGITS[country];
}

/** True once the postal code is long enough to be looked up in this country. */
// @ai-generated 2026-08-17T13:24:12+00:00 by matthias.gessinger@synqony.com using Claude Opus 5
export function isCompletePostalCode(country: EnumCountry, zipCode: string): boolean {
    const digits = POSTAL_CODE_DIGITS[country];
    if (digits === undefined) {
        return false;
    }
    const trimmed = zipCode.trim();
    return trimmed.length === digits && /^\d+$/.test(trimmed);
}
